/**
 * Trunnion AI - Favorite (Star) Toggle Button
 */

import { Star } from 'lucide-react';
import { useFavorites } from '@/hooks/useFavorites';

interface FavoriteButtonProps {
  type: string;
  id: string;
  label: string;
  className?: string;
}

export function FavoriteButton({ type, id, label, className = '' }: FavoriteButtonProps) {
  const { toggleFavorite, isFavorite } = useFavorites();
  const active = isFavorite(type, id);

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(type, id, label);
      }}
      className={`rounded-lg p-1.5 transition-colors ${
        active
          ? 'text-trunnion-gold-500 hover:text-trunnion-gold-400'
          : 'text-trunnion-slate-500 hover:text-trunnion-slate-300'
      } ${className}`}
      title={active ? 'Remove from favorites' : 'Add to favorites'}
    >
      <Star className={`h-4 w-4 ${active ? 'fill-current' : ''}`} />
    </button>
  );
}
